import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import ClipboardCopy from '@components/Icon/ClipboardCopy'
import copy from 'copy-to-clipboard'

const handleCopy = ({ value, growlStore }) => {
  if (value) {
    copy(value)
    return growlStore.showSuccess(`"${value}" copied.`)
  }

  return growlStore.showError(`Nothing to copy.`)
}

const CopyButton = props => (
  <div className='clipboard-copy' onClick={() => handleCopy(props)}>
    <ClipboardCopy small={props.small || false} gray />
  </div>
)

CopyButton.propTypes = {
  small: PropTypes.bool
}

export default inject('growlStore')(observer(CopyButton))
